import { render, staticRenderFns } from "./exam-record.vue?vue&type=template&id=98fd6d7c&scoped=true"
import script from "./exam-record.vue?vue&type=script&lang=js"
export * from "./exam-record.vue?vue&type=script&lang=js"
import style0 from "./exam-record.vue?vue&type=style&index=0&id=98fd6d7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fd6d7c",
  null
  
)

export default component.exports